export default __webpack_public_path__ + "static/media/c_web_projekt_bg_gray.8e3c86e2.jpg";